const NO_TRACKING_COOKIE = 'rask_no_tracking=1';

export const isTrackingDisabled = () =>
  typeof document !== 'undefined' && document.cookie.split('; ').includes(NO_TRACKING_COOKIE);
